var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasyGenie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 51,
    viewBox: "0 0 108 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.000110865,
    y: -1.27591,
    width: 107.38,
    height: 51.6555
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.96px)",
      clipPath: "url(#bgblur_0_2034_1142_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2034_1142)",
    "data-figma-bg-blur-radius": 1.91388
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 101,
    height: 44,
    rx: 9.56942,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 101,
    height: 44,
    rx: 9.56942,
    fill: "url(#paint0_linear_2034_1142)",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 101,
    height: 44,
    rx: 9.56942,
    fill: "url(#paint1_linear_2034_1142)",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.50868,
    y: 0.956951,
    width: 100.362,
    height: 43.362,
    rx: 9.25044,
    stroke: "url(#paint2_radial_2034_1142)",
    strokeWidth: 0.637962,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.841 20.638H52.4347L54.9951 13.3652H56.6215L59.1854 20.638H57.7792L55.8367 14.8567H55.7799L53.841 20.638ZM53.8871 17.7864H57.7224V18.8446H53.8871V17.7864ZM64.3097 16.6252L63.1379 16.753C63.1047 16.6347 63.0467 16.5234 62.9638 16.4192C62.8834 16.3151 62.7745 16.231 62.6371 16.1671C62.4998 16.1032 62.3317 16.0712 62.1329 16.0712C61.8654 16.0712 61.6405 16.1292 61.4582 16.2452C61.2782 16.3612 61.1895 16.5115 61.1918 16.6962C61.1895 16.8548 61.2475 16.9839 61.3658 17.0833C61.4866 17.1827 61.6854 17.2644 61.9624 17.3283L62.8928 17.5272C63.4089 17.6384 63.7924 17.8148 64.0434 18.0563C64.2967 18.2978 64.4245 18.6138 64.4269 19.0044C64.4245 19.3477 64.3239 19.6508 64.1251 19.9135C63.9286 20.174 63.6551 20.3776 63.3048 20.5243C62.9544 20.6711 62.5519 20.7445 62.0974 20.7445C61.4298 20.7445 60.8923 20.6048 60.4852 20.3255C60.078 20.0437 59.8353 19.6519 59.7572 19.15L61.0107 19.0293C61.0675 19.2755 61.1883 19.4614 61.3729 19.5868C61.5576 19.7123 61.7979 19.775 62.0938 19.775C62.3992 19.775 62.6442 19.7123 62.8289 19.5868C63.0159 19.4614 63.1094 19.3063 63.1094 19.1216C63.1094 18.9654 63.0491 18.8364 62.9283 18.7346C62.81 18.6328 62.6253 18.5546 62.3744 18.5002L61.444 18.3049C60.9208 18.196 60.5337 18.0125 60.2827 17.7544C60.0318 17.494 59.9075 17.165 59.9099 16.7672C59.9075 16.4311 59.9986 16.1399 60.1833 15.8937C60.3703 15.6451 60.6296 15.4533 60.961 15.3184C61.2948 15.1811 61.6795 15.1124 62.1151 15.1124C62.7543 15.1124 63.2574 15.2485 63.6244 15.5208C63.9937 15.793 64.2221 16.1612 64.3097 16.6252ZM66.6588 18.9263L66.6553 17.3745H66.8612L68.8214 15.1834H70.3236L67.9124 17.8681H67.646L66.6588 18.9263ZM65.4869 20.638V13.3652H66.7724V20.638H65.4869ZM68.9102 20.638L67.1347 18.1557L68.0011 17.2502L70.4479 20.638H68.9102ZM59.4056 29.0016C59.4056 29.7852 59.2588 30.4564 58.9653 31.0151C58.6741 31.5714 58.2763 31.9976 57.7721 32.2935C57.2702 32.5894 56.7008 32.7374 56.064 32.7374C55.4271 32.7374 54.8566 32.5894 54.3523 32.2935C53.8504 31.9952 53.4527 31.5679 53.1592 31.0115C52.868 30.4528 52.7224 29.7829 52.7224 29.0016C52.7224 28.218 52.868 27.548 53.1592 26.9917C53.4527 26.433 53.8504 26.0056 54.3523 25.7097C54.8566 25.4138 55.4271 25.2658 56.064 25.2658C56.7008 25.2658 57.2702 25.4138 57.7721 25.7097C58.2763 26.0056 58.6741 26.433 58.9653 26.9917C59.2588 27.548 59.4056 28.218 59.4056 29.0016ZM58.081 29.0016C58.081 28.45 57.9946 27.9848 57.8218 27.606C57.6513 27.2249 57.4146 26.9372 57.1116 26.7431C56.8085 26.5466 56.4593 26.4483 56.064 26.4483C55.6686 26.4483 55.3194 26.5466 55.0164 26.7431C54.7134 26.9372 54.4754 27.2249 54.3026 27.606C54.1322 27.9848 54.0469 28.45 54.0469 29.0016C54.0469 29.5532 54.1322 30.0196 54.3026 30.4008C54.4754 30.7795 54.7134 31.0672 55.0164 31.2637C55.3194 31.4578 55.6686 31.5549 56.064 31.5549C56.4593 31.5549 56.8085 31.4578 57.1116 31.2637C57.4146 31.0672 57.6513 30.7795 57.8218 30.4008C57.9946 30.0196 58.081 29.5532 58.081 29.0016ZM60.6512 32.638V25.3652H61.9686V28.7069H62.0574L64.8948 25.3652H66.5034L63.6909 28.6287L66.5283 32.638H64.9445L62.7747 29.5201L61.9686 30.4718V32.638H60.6512ZM74.7714 27.6877C74.7122 27.4959 74.6305 27.3243 74.5263 27.1728C74.4245 27.0189 74.3014 26.8875 74.157 26.7786C74.015 26.6697 73.8516 26.588 73.667 26.5336C73.4823 26.4767 73.2811 26.4483 73.0633 26.4483C72.6727 26.4483 72.3246 26.5466 72.0192 26.7431C71.7138 26.9396 71.4736 27.2284 71.2984 27.6096C71.1255 27.9883 71.0391 28.45 71.0391 28.9945C71.0391 29.5437 71.1255 30.0089 71.2984 30.3901C71.4712 30.7713 71.7115 31.0613 72.0192 31.2601C72.327 31.4566 72.6845 31.5549 73.0917 31.5549C73.461 31.5549 73.7806 31.4839 74.0505 31.3418C74.3227 31.1998 74.5323 30.9985 74.679 30.7381C74.8258 30.4753 74.8992 30.1676 74.8992 29.8148L75.1975 29.861H73.2231V28.8312H76.1741V29.7047C76.1741 30.3274 76.0415 30.866 75.7763 31.3205C75.5112 31.775 75.1466 32.1254 74.6826 32.3716C74.2186 32.6155 73.6859 32.7374 73.0846 32.7374C72.4146 32.7374 71.8263 32.5871 71.3197 32.2864C70.8154 31.9834 70.4212 31.5537 70.1371 30.9973C69.8554 30.4386 69.7146 29.7758 69.7146 29.0087C69.7146 28.4216 69.7974 27.8972 69.9631 27.4356C70.1312 26.9739 70.3656 26.5821 70.6663 26.2601C70.9669 25.9358 71.3197 25.6896 71.7245 25.5215C72.1293 25.351 72.5697 25.2658 73.0455 25.2658C73.448 25.2658 73.8232 25.325 74.1712 25.4434C74.5192 25.5594 74.8282 25.7251 75.0981 25.9405C75.3703 26.156 75.5941 26.4116 75.7692 26.7076C75.9444 27.0035 76.0593 27.3302 76.1137 27.6877H74.7714ZM79.806 32.7445C79.2591 32.7445 78.7868 32.6309 78.3891 32.4036C77.9937 32.174 77.6895 31.8496 77.4765 31.4306C77.2634 31.0092 77.1568 30.5132 77.1568 29.9427C77.1568 29.3816 77.2634 28.8892 77.4765 28.4654C77.6919 28.0392 77.9926 27.7078 78.3784 27.4711C78.7643 27.232 79.2177 27.1124 79.7385 27.1124C80.0747 27.1124 80.3919 27.1669 80.6902 27.2758C80.9909 27.3823 81.256 27.548 81.4857 27.7729C81.7177 27.9978 81.9 28.2843 82.0326 28.6323C82.1651 28.9779 82.2314 29.3899 82.2314 29.8681V30.2623H77.7605V29.3958H80.9992C80.9968 29.1496 80.9435 28.9306 80.8394 28.7388C80.7352 28.5447 80.5896 28.392 80.4026 28.2807C80.2179 28.1695 80.0025 28.1138 79.7563 28.1138C79.4935 28.1138 79.2627 28.1777 79.0638 28.3056C78.8649 28.4311 78.7099 28.5968 78.5986 28.8027C78.4897 29.0063 78.4341 29.2301 78.4317 29.4739V30.2303C78.4317 30.5475 78.4897 30.8198 78.6057 31.0471C78.7217 31.272 78.8839 31.4448 79.0922 31.5655C79.3006 31.6839 79.5444 31.7431 79.8238 31.7431C80.0108 31.7431 80.1801 31.717 80.3316 31.665C80.4831 31.6105 80.6145 31.5312 80.7257 31.427C80.837 31.3229 80.9211 31.1938 80.9779 31.04L82.1782 31.1749C82.1024 31.4921 81.958 31.7691 81.7449 32.0059C81.5342 32.2402 81.2643 32.4225 80.9353 32.5527C80.6062 32.6806 80.2298 32.7445 79.806 32.7445ZM84.6045 29.4419V32.638H83.319V27.1834H84.5477V28.1103H84.6116C84.737 27.8049 84.9371 27.5622 85.2117 27.3823C85.4887 27.2024 85.8308 27.1124 86.238 27.1124C86.6144 27.1124 86.9423 27.1929 87.2217 27.3539C87.5034 27.5149 87.7212 27.7481 87.8751 28.0535C88.0313 28.3589 88.1083 28.7294 88.1059 29.165V32.638H86.8204V29.3638C86.8204 28.9992 86.7257 28.714 86.5363 28.508C86.3493 28.302 86.09 28.199 85.7586 28.199C85.5337 28.199 85.3336 28.2488 85.1584 28.3482C84.9856 28.4453 84.8495 28.5861 84.7501 28.7708C84.653 28.9554 84.6045 29.1792 84.6045 29.4419ZM89.4127 32.638V27.1834H90.6982V32.638H89.4127ZM90.059 26.4093C89.8554 26.4093 89.6802 26.3418 89.5334 26.2069C89.3867 26.0696 89.3133 25.905 89.3133 25.7133C89.3133 25.5191 89.3867 25.3546 89.5334 25.2196C89.6802 25.0823 89.8554 25.0137 90.059 25.0137C90.265 25.0137 90.4402 25.0823 90.5846 25.2196C90.7314 25.3546 90.8048 25.5191 90.8048 25.7133C90.8048 25.905 90.7314 26.0696 90.5846 26.2069C90.4402 26.3418 90.265 26.4093 90.059 26.4093ZM94.4349 32.7445C93.888 32.7445 93.4157 32.6309 93.018 32.4036C92.6226 32.174 92.3184 31.8496 92.1054 31.4306C91.8923 31.0092 91.7858 30.5132 91.7858 29.9427C91.7858 29.3816 91.8923 28.8892 92.1054 28.4654C92.3208 28.0392 92.6215 27.7078 93.0073 27.4711C93.3932 27.232 93.8466 27.1124 94.3674 27.1124C94.7036 27.1124 95.0208 27.1669 95.3191 27.2758C95.6198 27.3823 95.885 27.548 96.1146 27.7729C96.3466 27.9978 96.5289 28.2843 96.6615 28.6323C96.794 28.9779 96.8603 29.3899 96.8603 29.8681V30.2623H92.3894V29.3958H95.6281C95.6257 29.1496 95.5725 28.9306 95.4683 28.7388C95.3641 28.5447 95.2185 28.392 95.0315 28.2807C94.8468 28.1695 94.6314 28.1138 94.3852 28.1138C94.1224 28.1138 93.8916 28.1777 93.6927 28.3056C93.4939 28.4311 93.3388 28.5968 93.2275 28.8027C93.1186 29.0063 93.063 29.2301 93.0606 29.4739V30.2303C93.0606 30.5475 93.1186 30.8198 93.2346 31.0471C93.3506 31.272 93.5128 31.4448 93.7211 31.5655C93.9295 31.6839 94.1733 31.7431 94.4527 31.7431C94.6397 31.7431 94.809 31.717 94.9605 31.665C95.112 31.6105 95.2434 31.5312 95.3546 31.427C95.4659 31.3229 95.55 31.1938 95.6068 31.04L96.8071 31.1749C96.7313 31.4921 96.5869 31.7691 96.3738 32.0059C96.1631 32.2402 95.8932 32.4225 95.5642 32.5527C95.2351 32.6806 94.8587 32.7445 94.4349 32.7445Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2034_1142)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.1897,
    y: 5.63797,
    width: 34,
    height: 33,
    rx: 8,
    fill: "#21A7DF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6897,
    y: 6.13797,
    width: 33,
    height: 32,
    rx: 7.5,
    stroke: "url(#paint3_linear_2034_1142)",
    strokeOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.113 23.1442C29.858 23.6474 28.5032 23.9578 27.0862 24.0382C26.8419 24.0521 26.5956 24.0591 26.3478 24.0591C26.0999 24.0591 25.8537 24.0521 25.6093 24.0382C24.192 23.9577 22.837 23.6472 21.5816 23.1438C18.9473 22.0873 16.7521 20.1812 15.3428 17.7685C17.5395 14.008 21.6453 11.478 26.3478 11.478C31.0503 11.478 35.1561 14.008 37.3528 17.7685C35.9433 20.1814 33.7478 22.0877 31.113 23.1442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5814 24.1231C21.278 24.0014 20.9803 23.8684 20.689 23.7247C19.7423 24.3851 18.942 25.2076 18.3394 26.146C19.3637 27.7411 20.9591 29.0013 22.8738 29.6998C23.7861 30.0326 24.771 30.2379 25.8011 30.2911H26.8745C27.9044 30.2379 29.7145 31.2483 27.086 33.7979C29.001 33.0995 33.3118 27.7413 34.3362 26.146C33.7353 25.2103 32.9379 24.3898 31.9947 23.7303C31.7068 23.872 31.4126 24.0033 31.1128 24.1235C29.8578 24.6267 28.503 24.9371 27.086 25.0175C26.8417 25.0314 26.5955 25.0384 26.3476 25.0384C26.0997 25.0384 25.8535 25.0314 25.6091 25.0175C24.1918 24.937 22.8368 24.6265 21.5814 24.1231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.041,
    y: 16.1593,
    width: 10.6365,
    height: 3.7618,
    rx: 1.8809,
    fill: "#162550"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2924,
    cy: 18.0194,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#04FED1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3378,
    cy: 27.2984,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#162550"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5524,
    cy: 18.0194,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#04FED1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5524,
    cy: 27.2984,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#162550"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1239,
    cy: 27.2984,
    rx: 0.696435,
    ry: 0.689663,
    fill: "#162550"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2034_1142",
    x: -0.000110865,
    y: -1.27591,
    width: 107.38,
    height: 51.6555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.55185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5949
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2034_1142"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.27592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.637962
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2034_1142",
    result: "effect2_dropShadow_2034_1142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2034_1142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2034_1142_clip_path",
    transform: "translate(0.000110865 1.27591)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.1897,
    y: 0.63797,
    width: 101,
    height: 44,
    rx: 9.56942
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2034_1142",
    x: 7.1897,
    y: 5.63797,
    width: 42,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.654902 0 0 0 0 0.87451 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2034_1142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2034_1142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2034_1142",
    x1: 83.5857,
    y1: 42.504,
    x2: 92.0901,
    y2: 1.78541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C44FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E368D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2034_1142",
    x1: 19.0467,
    y1: 44.506,
    x2: 42.1568,
    y2: 13.8261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E368D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C44FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2034_1142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(84 57.5 -153.57 57.0186 35.6897 8.13797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E368D",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2034_1142",
    x1: 9.1897,
    y1: 22.138,
    x2: 43.1897,
    y2: 22.1568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C94AB",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878072,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C94AB",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyGenie);
export default __webpack_public_path__ + "static/media/easy-genie.0847578e3edb7b87588cde571f50946a.svg";
export { ForwardRef as ReactComponent };